import moment from "moment";
import utils from "../services/utils";
import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    kpis: {
      campaigns: [],
      columnType: 'week',
      columnCount: 4
    },
    // Make sure to update resetFilters
    funnel: {
      campaigns: [],
      timeframe: 3,
      readableTimeframe: {start: '', end: '', start_at: null, end_at: moment()},
      customDates: [],
    },
    // Make sure to update resetFilters
    email: {
      timeframesFilter: 'last_7'
    },
  },
});

const getters = {
  kpisFilters(state, getters, rootState, rootGetters) {
    let kpisFilter = utils.clone(state.filters.kpis);

    kpisFilter.campaigns = state.filters.kpis.campaigns.filter(campaignId => {
      if (campaignId === null) return true;
      return rootGetters.activeCampaigns.find(activeCampaign => activeCampaign.id === campaignId);
    });

    return kpisFilter;
  },
  funnelFilters(state, getters, rootState, rootGetters) {
    let funnelFilter = utils.clone(state.filters.funnel);

    funnelFilter.campaigns = state.filters.funnel.campaigns.filter(campaignId => {
      if (campaignId === null) return true;
      return rootGetters.activeCampaigns.find(activeCampaign => activeCampaign.id === campaignId);
    });

    return funnelFilter;
  },
};

const mutations = {
  // Set one filter
  setOneFilter(state, [filterName, filter, value]) {
    state.filters[filterName][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
  // Reset filters
  resetKPIsFilters(state) {
    // Make sure to update state default
    state.filters.kpis = {
      campaigns: [],
      columnType: 'week',
      columnCount: 4
    };

    store.dispatch('updateUserAppFilter')
  },
  resetFunnelFilters(state) {
    // Make sure to update state default
    state.filters.funnel = {
      campaigns: [],
      timeframe: 3,
      readableTimeframe: {start: '', end: '', start_at: null, end_at: moment()},
      customDates: [],
    };

    store.dispatch('updateUserAppFilter')
  },
  resetEmailFilters(state) {
    // Make sure to update state default
    state.filters.email = {
      timeframesFilter: 'last_7'
    };

    store.dispatch('updateUserAppFilter')
  },
};

const actions = {};

const StatsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default StatsStore;
